import React from 'react'
import Shimmer from 'Components/shimmer'
// import Image from 'next/image'
import ImageFallback from 'Components/imagefallback'
import vars from 'Consts/vars'

const VideoBlog = ({ video }) => (
  <React.Fragment>
    {video.status === "fetch_loading" ? (
      <div className="sidebar-content">
        <div className="row-shimmer">
          {[...Array(4).keys()].map((index) => (
            <div key={String(index)} className="col-shimmer-video">
              <div>
                <Shimmer height="60px" width="100%" />
              </div>
              <div>
                <Shimmer width="100%" />
                <Shimmer width="100%" />
                <Shimmer width="100%" />
              </div>
            </div>
          ))}
        </div>
      </div>
    ) : Array.isArray(video?.data) && video?.data?.length > 0 ? (
      <div className="sidebar-content">
        <div className="sidebar-title-wrapper">
          <h3 className="sidebar-content-title">Video</h3>
        </div>
        {video?.data?.map((item, idx) => (
          <a
            key={String(idx)}
            href={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/blog${
              item.url.split('blog')[1]
            }`}
            className="highlight-wrapper"
          >
            <div className="highlight-img">
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  position: 'relative',
                }}
              >
                <ImageFallback
                  src={item.image}
                  alt={item.title}
                  layout="fixed"
                  objectFit="cover"
                  width={102}
                  height={57}
                  quality={80}
                  fallbackSrc={vars.imageBrokenDefault.rectangle}
                />
              </div>
            </div>
            <div className="highlight-text">
              <p className="highlight-category">
                {item.category_slug.replace(/_/gi, ' ').toUpperCase()}
              </p>
              <p className="highlight-title">{item.title}</p>
            </div>
          </a>
        ))}
      </div>
    ) : null}
  </React.Fragment>
)

export default VideoBlog
